import React, { FunctionComponent, ReactNode } from 'react';
import Slider from 'react-slick';
import { ArrowButton, CarouselContainer, ExclusiveCarouselContainer } from './CursoLivreCarousel.styled';

const NextArrow = (props: any) => (
    <ArrowButton type="button" className={`${props.className ?? ''} next`} onClick={props.onClick} aria-label="Próximos cursos" />
);

const PreviousArrow = (props: any) => (
    <ArrowButton type="button" className={`${props.className ?? ''} prev`} onClick={props.onClick} aria-label="Cursos anteriores" />
);

interface ICursoLivreCarouselProps {
    children: ReactNode[];
    exclusive?: boolean;
}

const CursoLivreCarousel: FunctionComponent<ICursoLivreCarouselProps> = ({ children, exclusive = false }) => {
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,

        slidesToShow: 4,
        slidesToScroll: 1,

        variableWidth: true,
        arrows: true,

        nextArrow: <NextArrow />,
        prevArrow: <PreviousArrow />,

        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    variableWidth: true,
                },
            },
            {
                breakpoint: 912,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    arrows: false,
                },
            },
        ],
    };

    const Container = exclusive ? ExclusiveCarouselContainer : CarouselContainer;

    return (
        <Container>
            <Slider {...settings}>{children}</Slider>
        </Container>
    );
};

export default React.memo(CursoLivreCarousel);
